export default "__VITE_ASSET__BlQudhyt__"